export const userStatuses = Object.freeze({
  registered: 'registered', // User created, but not verified
  active: 'active', // got request within the last 15 minutes
  inactive: 'inactive', // 15 minutes < last seen < 2 weeks
  absent: 'absent', // last seen > 2 weeks
  suspended: 'suspended', // Admin initiated account suspension
  deactivated: 'deactivated', // User initiated account deactivation
})
